import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleSelect", "organizationSection", "userTypeHidden"]

  connect() {
    this.toggleSections()
  }

  toggleSections() {
    const role = this.roleSelectTarget.value
    const isRegularUser = (role === "regular")

    // Toggle organization section visibility
    if (this.hasOrganizationSectionTarget) {
      if (isRegularUser) {
        this.organizationSectionTarget.classList.remove("hidden")
      } else {
        this.organizationSectionTarget.classList.add("hidden")
      }
    }

    // Update hidden field for user_type
    if (this.hasUserTypeHiddenTarget) {
      this.userTypeHiddenTarget.value = role
    }
  }
}
